

















import { DirectiveOptions } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ValidationMessageCpt, BaseInputComponent } from '.';

// This is to add an aria-label to the upload input, and make it readable by screen readers
const SetAriaLabelDirective: DirectiveOptions = {
  inserted(el, binding) {
    setTimeout(() => {
      // those are needed to add accessibility to these buttons
      // TypeScript 3.5.3 does not support the optional chaining (?.) operator.
      // Optional chaining was introduced in TypeScript 3.7.
      const nmButton = el.querySelector('.el-upload__input');
      nmButton?.setAttribute('aria-label', binding.value);
    }, 100); // Ensure input is fully rendered before modifying it
  },
};

@Component({
  components: {
    ValidationMessageCpt,
  },
  directives: {
    setAriaLabel: SetAriaLabelDirective,
  },
})
export default class InputUploadCpt extends BaseInputComponent {
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: false }) multiple: boolean;
  @Prop({ default: '.xlsx,.xls,.csv' }) accept: string;

  get internalLabel() {
    return !this.label ? 'Drop file here or click to upload' : this.label;
  }

  httpRequest(file: any) {
    this.$emit('http-request', file);
  }

  clearFiles() {
    const uploadRef: any = this.$refs.upload;
    uploadRef.clearFiles();
  }
}
